module.exports = __webpack_public_path__ + "media/images/club-award-31fc7213eb93818cc2f4152adfd3a8b6.jpg";